export const GET_TOTAL_STATS = 'RPTS/get_total_stats';
export const GET_GRAPH_STATS = 'RPTS/get_graph_stats';

export const LEGENDS_WITH_TAX_CLEARANCE = [
    { name: 'TAX CLEARANCE', color: '#5272AA', value: 0 },
    { name: 'TAX PAYMENT', color: '#A3B3F9', value: 0 },
];

export const LEGENDS = [
    // { name: 'TAX CLEARANCE', color: '#5272AA', value: 0 },
    { name: 'TAX PAYMENT', color: '#A3B3F9', value: 0 },
];
